const duProvisioning = 'https://du.dev.24orepro.in.ilsole24ore.it';
const duHost = 'https://du.ilsole24ore.com/du';
const duHostUsers = 'https://du.ilsole24ore.com/utenti';
const paywallDomain = 'https://abbonamenti-dlv.ilsole24ore.com';
const checkoutDomain = 'http://abbonamenti-dlv.ilsole24ore.com';
const soleproDomain = 'https://24orepro-dlv.ilsole24ore.com';
const usersDu = 'https://api24.ilsole24ore.com/Users';
const my25Services = 'https://areautente.ilsole24ore.com/my24services/Services';

module.exports = {
  duProvisioning,
  duHost,
  duHostUsers,
  paywallDomain,
  checkoutDomain,
  soleproDomain,
  usersDu,
  my25Services,
};